module.exports = __webpack_public_path__ + "media/images/reg_1_redesign_arrow_back-d016e695.png";